import { Component, default as React } from 'react';
import { BillDto } from 'ts-types/api.types';
import axios, { CancelTokenSource } from 'axios';

interface Props {
  children: JSX.Element | Array<JSX.Element>
}

interface State {
  bills: Array<BillDto>,
  setBills: (newBills: Array<BillDto>) => void,
  appendBills: (newBills: Array<BillDto>) => void,
  selectedBill?: BillDto,
  setSelectedBill: (bill: BillDto) => void,
  cancelTokenSource: CancelTokenSource
}

const cancelTokenSource = axios.CancelToken.source();

export const BillContext = React.createContext<State>({
  bills: [],
  setBills: () => {},
  appendBills: () => {},
  setSelectedBill: () => {},
  cancelTokenSource: cancelTokenSource
});

export class BillProvider extends Component<Props, State> {

  private mounted: boolean = false;

  constructor(props: Props) {
    super(props);

    this.state = {
      bills: [],
      setBills: this.setBills,
      appendBills: this.appendBills,
      setSelectedBill: this.setSelectedBill,
      cancelTokenSource
    }
  }

  componentDidMount(): void {
    this.mounted = true;
  }

  componentWillUnmount(): void {
    this.mounted = false;

    const { cancelTokenSource } = this.state;
    cancelTokenSource.cancel('Operation canceled by user');
  }

  setBills = (newBills: Array<BillDto>) => {
    if(!this.mounted){
      return;
    }

    this.setState({
      bills: [...newBills]
    })
  };

  appendBills = (newBills: Array<BillDto>) => {
    if(!this.mounted){
      return;
    }

    const { bills } = this.state;

    this.setState({
      bills: [...bills, ...newBills]
    })
  };

  setSelectedBill = (bill: BillDto) => {
    if(!this.mounted){
      return;
    }

    this.setState({
      selectedBill: bill
    })
  };

  render() {
    return (
        <BillContext.Provider value={this.state}>
          { this.props.children }
        </BillContext.Provider>
    );
  }
}

export const BillConsumer = BillContext.Consumer;
export interface BillConsumerRenderProps extends State {}

export const withBillContext = (Component: typeof React.Component | React.FunctionComponent<any> ) => {
  return (props: any) => (
      <BillConsumer>
        {({...billProps}: BillConsumerRenderProps) => {
          return <Component {...props} {...billProps} />
        }}
      </BillConsumer>
  );
};
